module.exports = __webpack_public_path__ + "static/img/Contact-info.cb37029.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Contact-info.png
// module id = jGXK
// module chunks = 0